import React from 'react'
import Categories from '../components/home/Categories'
import Products from '../components/home/Products'
const Home = () => {

  return (
    <>

        <Categories />
        <Products />
    </>

  )
}

export default Home